import { Link } from "react-router-dom";

const categoryLinks = [
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "演员资料", to: "/category/actor" },
];

const aboutLinks = [
  { label: "关于我们", to: "/about" },
  { label: "网站简介", to: "/about#intro" },
  { label: "联系方式", to: "/about#contact" },
  { label: "用户反馈", to: "/about#feedback" },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-auto bg-primary-950 text-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-2">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-950">
              <i className="ri-film-line text-lg" />
            </span>
            <span className="font-heading font-black text-xl">葵司</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-300">
            葵司是面向影视爱好者与行业从业者的综合影视内容站，提供最新影视资讯、演员资料与作品动态，让查询与浏览更简单。
          </p>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm mb-4 text-background-100">
            <span className="inline-block">影视分类</span>
          </h4>
          <ul className="space-y-2 text-sm">
            {categoryLinks.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-background-300 hover:text-accent-400 transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm mb-4 text-background-100">
            <span className="inline-block">关于与帮助</span>
          </h4>
          <ul className="space-y-2 text-sm">
            {aboutLinks.map((l) => (
              <li key={l.label}>
                <Link
                  to={l.to}
                  className="text-background-300 hover:text-accent-400 transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm mb-4 text-background-100">
            <span className="inline-block">友情链接</span>
          </h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/category/movie"
                className="text-background-300 hover:text-accent-400 transition-colors"
              >
                院线新片速递
              </Link>
            </li>
            <li>
              <Link
                to="/category/actor"
                className="text-background-300 hover:text-accent-400 transition-colors"
              >
                演员资料大全
              </Link>
            </li>
            <li>
              <Link
                to="/search?q=悬疑"
                className="text-background-300 hover:text-accent-400 transition-colors"
              >
                悬疑题材专题
              </Link>
            </li>
            <li>
              <Link
                to="/search?q=科幻"
                className="text-background-300 hover:text-accent-400 transition-colors"
              >
                科幻题材专题
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="max-w-content mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© {year} 葵司 KUISI · 保留所有权利</p>
          <p className="text-center sm:text-right">
            本站内容均为演示用途的虚构数据，仅供产品展示，不构成任何商业信息。
          </p>
        </div>
      </div>
    </footer>
  );
}